// extracted by mini-css-extract-plugin
module.exports = {"page":"edit_page_1CWXB","card-wrapper":"edit_card-wrapper_1d7JE","footer":"edit_footer_2CO7e"};